import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { onChangeUseState } from "../../helpers/FunctionsGlobal";
import { available_countries } from "../../helpers/GlobalOptions";
import useErrors from "../../hooks/useErrors";
import useFetch from "../../hooks/useFetch";
import { updateEnergyLabel } from "../../redux/Actions/energy_labels_action";
import AutosysSku from "../Autosys/AutosysSku";
import { ButtonSecondary } from "../common";
import SelectInput from "../common/SelectInput";
import TextInputModal from "../common/TextInputModal";
import { InitialData, Label } from "../globals";
import DataSheetItem from "./DataSheetItem";

export default function EnergyLabelModal({ modalOpt, onClose, options }) {
  const dispatch = useDispatch();
  const [formLoading, setFormLoading] = useState(false);

  const { errors, setErrors } = useErrors();
  const { loading, error, value, setValue } = useFetch(
    `/api/v1/energy_labels/${
      modalOpt.type == "create" ? "new" : modalOpt.record_id
    }`
  );
  const energy_documents = useMemo(() => {
    console.count("energy_documents");
    const initial = Object.fromEntries(
      [...available_countries, { value: "label_image" }].map((country) => [
        country.value,
        {},
      ])
    );
    if (!loading && value?.energy_documents) {
      // console.log("here");
      value.energy_documents
        .filter((d) => !d._destroy)
        .filter((d) => d?.asset?.url)
        .forEach((document) => {
          // console.log({ document });
          initial[document.label_type] = document;
        });
    }
    return initial;
  }, [loading, JSON.stringify(value?.energy_documents)]);

  if (loading || error || !value) {
    return <InitialData loading={loading} error={error} value={value} />;
  }

  const onSubmit = async () => {
    try {
      setFormLoading(true);
      const { success, errors } = await dispatch(updateEnergyLabel(value));
      if (success) {
        onClose();
      } else {
        console.log({ errors });
        setErrors(errors);
      }
    } catch (err) {
      console.error("ERROR: ", err);
    } finally {
      setFormLoading(false);
    }
  };
  return (
    <div
      className="d-flex flex-column jusitfy-content-between"
      style={{
        height: "100%",
      }}
    >
      <div className="flex-1">
        {/* SKU */}
        <AutosysSku
          type="energy"
          warning={errors["energy_products.sku"]}
          products={value.energy_products}
          setValue={setValue}
        />
        {/* SKU */}
        {/* Energy class */}
        <SelectInput
          value_return={"simple"}
          required={true}
          label="Energy Class Image"
          options={options?.energy_class_image}
          name="energy_class"
          value={value.energy_class || undefined}
          onChange={onChangeUseState(setValue)}
          error={errors.energy_class}
        />
        <div className="my-1" />
        {/* Energy class */}
        {/* Eprel ID */}
        <TextInputModal
          disabled={true}
          required={true}
          text="Eprel ID"
          name="eprel_id"
          value={value.eprel_id || undefined}
          onChange={onChangeUseState(setValue)}
          warning={errors.eprel_id}
        />
        <div className="my-2" />
        {/* Eprel ID */}
        {/* Data sheets */}
        <Label required={true}>Data sheets</Label>
        {available_countries.map((country) => (
          <DataSheetItem
            key={country.value}
            {...country}
            document={energy_documents[country.value]}
            setValue={setValue}
          />
        ))}
        <div className="my-1" />
        {/* Data sheets */}
        {/* Label image */}
        <Label required={true}>Label image</Label>
        <DataSheetItem
          label="label_image"
          value="label_image"
          document={energy_documents["label_image"]}
          setValue={setValue}
        />

        {/* Label image */}
      </div>
      <div>
        <ButtonSecondary
          onClick={onSubmit}
          loading={loading || formLoading}
          disabled={loading || formLoading}
        >
          {modalOpt.type == "create" ? "Create" : "Save"}
        </ButtonSecondary>
      </div>
    </div>
  );
}
